import { IObserver } from '@1js/oil-externals/rx';
import { SearchResultType } from '../search-instrumentation.service';
import { TellMeSearchSuggestionProvider } from './tellme.search-suggestion-provider';
/*
 * Data provider for Help search result.
 */
export class HelpSearchSuggestionProvider extends TellMeSearchSuggestionProvider {

    private readonly maxCount = 3;

    public getId(): string {
        return 'help';
    }

    public getSearchSuggestion(_searchText: string, searchSuggestion: Object, observer: IObserver<any>) {

        const jsonResponse = searchSuggestion;
        const renderedResults: Array<string> = [];
        let helpSuggestions;

        try {
            if (jsonResponse['Groups'] && jsonResponse['Groups'].length > 0) {
                for (let groupCount = 0; groupCount < jsonResponse['Groups'].length; groupCount++ ) {
                    if (jsonResponse['Groups'][groupCount]['GroupType'] === 'Help') {
                        helpSuggestions = jsonResponse['Groups'][groupCount]['Suggestions'];
                        break;
                    }
                }

                if (helpSuggestions) {
                    for (let count = 0; count < this.maxCount && count < helpSuggestions.length; count++ ) {
                        observer.onNext(
                            {
                                id: count.toString(),
                                title: helpSuggestions[count]['name'],
                                articleId: helpSuggestions[count]['id'],
                                isPwa: HelpSearchSuggestionProvider.capabilitiesService.capabilities.isPwaInUwp,
                                isDarkMode: HelpSearchSuggestionProvider.isDarkMode,
                                shellShim: HelpSearchSuggestionProvider.shellShim,
                                searchInstrumentationService: HelpSearchSuggestionProvider.searchInstrumentationService
                            });
                        renderedResults.push(helpSuggestions[count]['id']);
                    }
                }
            }
        } catch (error) {
            observer.onCompleted();
        }

        HelpSearchSuggestionProvider.searchInstrumentationService.setRenderedProviderResults(SearchResultType.Help, renderedResults);
        observer.onCompleted();
    }

    public getMockedSearchSuggestion(_searchText: string, observer: IObserver<any>) {
        observer.onNext(
            {
                id: '0',
                title: 'Use a template to create a resume',
                articleId: '6053fbbb-94d8-471e-9957-49f4e7ab6fb8',
                isPwa: HelpSearchSuggestionProvider.capabilitiesService.capabilities.isPwaInUwp,
                isDarkMode: HelpSearchSuggestionProvider.isDarkMode,
                shellShim: HelpSearchSuggestionProvider.shellShim,
                searchInstrumentationService: HelpSearchSuggestionProvider.searchInstrumentationService
            });
        observer.onCompleted();
    }
}
